export default "/_next/static/assets/fonts/GoodOT-Ultra.256058413676b3e13927ccc53c298a62.woff2";